import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { getQuestionnairesTable } from '../../Model/QuestionnaireTableModel'
import { IQuestionnaire, QuestionnaireStatus } from '../../Model/Questionnaire'
import ExportToCsvComponent from '../../Components/ExportToCsvComponent'
import { ExportType } from '../../Stores/ExportStore'
import PageSizeComponent from '../../Components/PageSizeComponent'
// import { getEventsTableHistory } from '../../Model/TroubleEventsTableItem'

export interface IQuestionnairesPageProps {
}

@inject('questionnairesStore')
@observer
export default class QuestionnairesPage extends React.Component<IQuestionnairesPageProps> {
    changeStatus(e: any, item: IQuestionnaire, status: QuestionnaireStatus) {
        return
    }

    render() {
        return (
            <div className="questionnaires row">
                <div className="page col-12">
                    <div className="dataChartImg">
                        {/* <img src="images/chart.png" alt="chart"/> */}
                        <PageSizeComponent/>
                        <ExportToCsvComponent exportType={ExportType.QAll}/>
                        {getQuestionnairesTable()}
                    </div>
                </div>
                {/* <div className="page col-12">
                    {getEventsTableHistory()}
                </div> */}
               
                {/* <div className="tip">
                    <em>{ls.t('Tip: Hold shift when sorting to multi-sort!')}</em>
                </div> */}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/DashboardPage.tsx